import { render, staticRenderFns } from "./AIAbility.vue?vue&type=template&id=b6e5274e&scoped=true"
import script from "./AIAbility.vue?vue&type=script&lang=js"
export * from "./AIAbility.vue?vue&type=script&lang=js"
import style0 from "./AIAbility.vue?vue&type=style&index=0&id=b6e5274e&prod&lang=scss&scoped=true"
import style1 from "./AIAbility.vue?vue&type=style&index=1&id=b6e5274e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e5274e",
  null
  
)

export default component.exports